import classNames from 'classnames'
import { MdArrowDownward, MdArrowUpward } from 'react-icons/md'

import type { ReactElement } from 'react'

import { formatVariationValue } from '~/utils/number'

import './styles.scss'

export function getDirection(value: number): 'up' | 'down' {
  return value > 0 ? 'up' : 'down'
}

interface Props {
  decimals?: number
  direction: 'down' | 'up'
  period?: string
  periodValue?: number
  reversed?: boolean
  value: number
}

const Variation = ({ decimals, direction, period, periodValue, reversed, value }: Props): ReactElement => {
  const variationValueContainerClasses = classNames('variation-value-container', {
    negative: reversed ? direction !== 'down' : direction === 'down',
    positive: reversed ? direction !== 'up' : direction === 'up',
  })

  return (
    <div className="variation-component">
      {period && periodValue ? (
        <>
          <span className="period-wrapper">
            <span className="grey">vs</span> {period}-{periodValue}
          </span>
          <div className="period-underline" />
        </>
      ) : null}
      <div className={variationValueContainerClasses}>
        {direction.length > 0 ? (
          <div className="icon-container">
            {direction === 'up' ? <MdArrowUpward color={reversed ? '#ff2e26' : '#00c064'} size={14} /> : null}
            {direction === 'down' ? <MdArrowDownward color={reversed ? '#00c064' : '#ff2e26'} size={14} /> : null}
          </div>
        ) : null}
        <span className="variation-value">
          {value > 0 ? '+' : ''}
          {formatVariationValue(value, decimals)}%
        </span>
      </div>
    </div>
  )
}

export default Variation
